import { Injectable } from '@angular/core';
import { Group } from 'ng2-dragula';
import * as autoScroll from 'dom-autoscroller';

interface ScrollElements {
  destroy(forceCleanAnimation?: boolean): void;
}

interface DrakeWithDragging {
  dragging: boolean;
}

@Injectable()
export class AutoScrollOnDragService {
  private readonly autoScroll: (
    scrolledElement: HTMLElement,
    options?: { margin?: number; scrollWhenOutside?: boolean; maxSpeed?: number; autoScroll?: Function }
  ) => ScrollElements = autoScroll;

  private scrollElements?: ScrollElements;

  public initializeScroll(dragula: Group, scrollElementSelector = '#content'): void {
    if (!dragula) {
      throw new Error('Dragula Group should be defined!');
    }

    const scrolledElement = document.querySelector(scrollElementSelector) as HTMLElement;
    if (!scrolledElement) {
      throw new Error('Scrolled element does not exist!');
    }
    this.scrollElements = this.autoScroll(scrolledElement, {
      margin: 100,
      maxSpeed: 30,
      scrollWhenOutside: true,
      autoScroll(): boolean {
        // don't use () => {} syntax to keep the 'this' of AutoScroller object
        return this.down && (dragula.drake as any as DrakeWithDragging).dragging;
      }
    });
  }

  public destroy(): void {
    if (this.scrollElements) {
      this.scrollElements.destroy(true);
    }
  }
}
